/**
 * Parses the zguid cookie value to extract the token.
 * zguid format: "part1|$token" -> returns "token"
 */
function parseZguid(zguid: string | undefined): string {
  if (!zguid) return '';

  const parts = zguid.split('|');
  if (parts.length !== 2) return '';

  const token = parts[1].replace(/^%24/, '');
  return token || '';
}

/**
 * Retrieves the zguid cookie value from the browser.
 * Only works on client-side (returns undefined on server).
 */
function getZguidCookie(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('zguid='))
    ?.split('=')[1];
}

/**
 * Retrieves and parses the zguid cookie from the browser.
 * Convenience function that combines getZguidCookie and parseZguid.
 */
export function getParsedZguid(): string {
  return parseZguid(getZguidCookie());
}
